export default[
    {
        path: '/advertencia/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro da advertencia do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/advertencia/trabalhador/lista',
        name: 'lista da advertencia do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/advertencia/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar advertencia do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]